import { cn } from '@/shared/lib/utils'

import type { ThemeVariant } from './theme-tokens'
import { themeVariantPageClass } from './theme-tokens'

type PageProps = {
  bgImageUrl?: string
  children: React.ReactNode
  className?: string
  variant?: ThemeVariant
}

export function Page({
  className = '',
  children,
  variant
}: PageProps) {
  return (
    <div
      className={cn(
        'relative flex flex-col items-center gap-4 px-4 lg:px-10 pt-18 lg:pt-10 min-h-screen h-full bg-cover bg-no-repeat',
        variant ? themeVariantPageClass[variant] : 'bg-primary-dark',
        className
      )}
    >
      {children}
      <div className="w-full h-[200px]"></div>
      <div className="absolute top-0 left-0 w-full h-full shadow-inner pointer-events-none select-none hidden lg:block inset-shadow-[0_2px_4px_0_#0d0101]" />
    </div>
  )
}
